import { createDayjsInstance } from './dayjs-wrapper';

export const getCurrentYear = (): number => createDayjsInstance().year();

export const isSameDay = (date1: string | Date, date2: string | Date): boolean => {
  return createDayjsInstance(date1).isSame(createDayjsInstance(date2), 'day');
};

export const convertDateToIsoString = (date: Date | string | null | undefined): string => {
  if (!date) {
    return '';
  }

  if (date instanceof Date) {
    return date.toISOString();
  }

  if (typeof date === 'string') {
    return date;
  }

  if (date != null) {
    try {
      return new Date(date).toISOString();
    } catch {
      return '';
    }
  }

  return '';
};
